import React, { useState } from 'react';
import { useWallet } from '../../contexts/WalletContext';

const WalletCreator = ({ onClose, onSuccess }) => {
  const { createPlatformWallet, isCreating, error } = useWallet();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleCreateWallet = async () => {
    const result = await createPlatformWallet();

    if (result.success) {
      if (onSuccess) {
        onSuccess(result.wallet);
      }
      if (onClose) {
        onClose();
      }
    }
  };

  const handleConfirmCreate = () => {
    setShowConfirmation(false);
    handleCreateWallet();
  };

  if (showConfirmation) {
    return (
      <div className="wallet-creator">
        <div className="wallet-creator-header">
          <h3>Create Platform Wallet</h3>
          <button
            className="close-button"
            onClick={onClose}
            disabled={isCreating}
          >
            ×
          </button>
        </div>

        <div className="wallet-creator-content">
          <div className="confirmation-section">
            <div className="warning-icon">⚠️</div>
            <h4>Important Security Information</h4>
            <div className="security-info">
              <p><strong>Your wallet will be created with the following security measures:</strong></p>
              <ul>
                <li>Private key will be encrypted using AES-256-GCM encryption</li>
                <li>Encrypted key will be stored securely in our database</li>
                <li>Only you can access your wallet through your account</li>
                <li>We recommend backing up your wallet address</li>
              </ul>

              <div className="warning-box">
                <p><strong>⚠️ Important:</strong> This is a platform-managed wallet. While secure, for maximum security consider using an external wallet like Phantom or Solflare for large amounts.</p>
              </div>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">❌</span>
              {error}
            </div>
          )}

          <div className="button-group">
            <button
              className="cancel-button"
              onClick={() => setShowConfirmation(false)}
              disabled={isCreating}
            >
              Back
            </button>
            <button
              className="create-button"
              onClick={handleConfirmCreate}
              disabled={isCreating}
            >
              {isCreating ? 'Creating Wallet...' : 'Create Wallet'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wallet-creator"
    >
      <div className="wallet-creator-header"
      >
        <h3>Create New Wallet</h3>
        <button
          className="close-button"
          onClick={onClose}
          disabled={isCreating}
        >
          ×
        </button>
      </div>

      <div className="wallet-creator-content" style={{
        height: '90vh'
      }}>
        <div className="wallet-option">
          <div className="option-icon">🏦</div>
          <div className="option-details">
            <h4>Platform Wallet</h4>
            <p>Create a new Solana wallet managed by our platform. Your private key will be encrypted and stored securely.</p>

            <div className="features-list">
              <div className="feature">
                <span className="feature-icon" style={{ fontSize: 23 }}>✅</span>
                <span>Automatic transaction signing</span>
              </div>
              <div className="feature">
                <span className="feature-icon" style={{ fontSize: 23 }}>✅</span>
                <span>Integrated with trading bot</span>
              </div>
              <div className="feature">
                <span className="feature-icon" style={{ fontSize: 23 }}>✅</span>
                <span>AES-256 encryption</span>
              </div>
              <div className="feature">
                <span className="feature-icon" style={{ fontSize: 23 }}>✅</span>
                <span>Easy to use</span>
              </div>
            </div>
          </div>
        </div>

        {error && (
          <div className="error-message">
            <span className="error-icon">❌</span>
            {error}
          </div>
        )}

        <div className="button-group">
          <button
            className="cancel-button"
            onClick={onClose}
            disabled={isCreating}
          >
            Cancel
          </button>
          <button
            className="create-button"
            onClick={() => setShowConfirmation(true)}
            disabled={isCreating}
          >
            Create Platform Wallet
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletCreator;